
export const resetState = () => {
    return {
      type: 'RESET_STATE',
    };
  };
  